import React, { useState, useEffect, useRef } from "react";
import {
  FaVideo,
  FaBell,
  FaUserCircle,
  FaSearch,
  FaMicrophone,
  FaHome,
  FaFire,
  FaSubscript,
  FaBookmark,
  FaHistory,
  FaBars,
  FaMoon,
  FaSun,
  FaPlay,
  FaCog,
  FaQuestionCircle,
  FaCommentAlt,
  FaThumbsUp,
  FaShare,
  FaEllipsisH,
  FaClock,
  FaCrown,
} from "react-icons/fa";

// Premium sample video data
const sampleVideos = [
  {
    id: 1,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjRkY2QUQ4Ii8+CjxwYXRoIGQ9Ik0xMzAgNzJMMTg4IDEwOEwxMzAgMTQ0VjcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "Building Amazing React Apps in 2025",
    channel: "TechMaster Pro",
    views: "2.4M",
    uploadTime: "2 days ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM0Qzc2RjIiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "12:34",
    premium: true,
  },
  {
    id: 2,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjMDBDQ0ZGIi8+CjxwYXRoIGQ9Ik0xMzAgNzJMMTg4IDEwOEwxMzAgMTQ0VjcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "CSS Grid vs Flexbox: Complete Guide 2025",
    channel: "Design Code",
    views: "890K",
    uploadTime: "5 days ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiMwMENDRkYiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "18:21",
    premium: false,
  },
  {
    id: 3,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjRkY5QzAwIi8+CjxwYXRoIGQ9Ik0xMzAgNzJMMTg4IDEwOEwxMzAgMTQ0VjcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "JavaScript Performance Tips for 2025",
    channel: "JS Ninja",
    views: "1.2M",
    uploadTime: "1 week ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGRjlDMDAiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "22:45",
    premium: true,
  },
  {
    id: 4,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjOEIzNUQ2Ii8+CjxwYXRoIGQ9Ik0xMzAgNzJMMTg4IDEwOEwxMzAgMTQ0VjcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "Node.js Best Practices 2025",
    channel: "Backend Masters",
    views: "567K",
    uploadTime: "3 days ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM4QjM1RDYiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBk�JNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "15:09",
    premium: false,
  },
  {
    id: 5,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjRkY0N0FFIi8+CjxwYXRoIGQ9Ik0xMzAgNzJMMTg4IDEwOEwxMzAgMTQ0VjcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "AI Development Trends 2025",
    channel: "AI Pioneers",
    views: "3.1M",
    uploadTime: "1 day ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGRjQ3QUUiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "28:17",
    premium: true,
  },
  {
    id: 6,
    thumbnail:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjMDBEQjgyIi8+CjxwYXRoIGQ9Ik0xMzUgNzVMMTg1IDEwOEwxMzUgMTQxVjc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+",
    title: "Web3 Development Masterclass",
    channel: "Blockchain Academy",
    views: "1.8M",
    uploadTime: "4 days ago",
    channelAvatar:
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiMwMERCODgiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIj4KICA8cGF0aCBkPSJNMTIgMTJoOHY4aC04eiIvPgo8L3N2Zz4KPC9zdmc+",
    duration: "35:42",
    premium: true,
  },
];

// Premium Dark Mode Toggle Component
const DarkModeToggle = ({ darkMode, toggleDarkMode }) => (
  <button
    className="btn btn-outline-light border-0 p-2 rounded-circle position-relative premium-toggle"
    onClick={toggleDarkMode}
    title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
    aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
    style={{
      background: darkMode
        ? "linear-gradient(145deg, #1a202c, #0f1419)"
        : "linear-gradient(145deg, #ffffff, #f0f0f0)",
      boxShadow: darkMode
        ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
        : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
    }}
  >
    {darkMode ? <FaSun size={18} /> : <FaMoon size={18} />}
  </button>
);

// Premium Navbar Component
const Navbar = ({ darkMode, toggleDarkMode, sidebarOpen, toggleSidebar }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  return (
    <nav
      className="navbar navbar-expand-lg sticky-top shadow-sm border-0 premium-navbar"
      style={{
        background: darkMode
          ? "linear-gradient(90deg, #0f1419 0%, #1a202c 100%)"
          : "linear-gradient(90deg, #ffffff 0%, #f8f9fa 100%)",
        borderBottom: darkMode ? "1px solid #2d3748" : "1px solid #e2e8f0",
        padding: "0.5rem 1rem",
      }}
    >
      <div className="container-fluid px-3">
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link text-decoration-none me-3 p-2 rounded-circle nav-icon"
            onClick={toggleSidebar}
            style={{
              color: darkMode ? "white" : "#1a202c",
              background: darkMode
                ? "linear-gradient(145deg, #1a202c, #0f1419)"
                : "linear-gradient(145deg, #ffffff, #f0f0f0)",
              boxShadow: darkMode
                ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
                : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
            }}
            aria-label="Toggle sidebar"
          >
            <FaBars size={18} />
          </button>
          <a
            className="navbar-brand d-flex align-items-center fw-bold premium-brand"
            href="#"
            style={{
              color: darkMode ? "white" : "#1a202c",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "1.5rem",
              fontWeight: "700",
              textShadow: darkMode
                ? "0 2px 4px rgba(255, 255, 255, 0.1)"
                : "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <span className="gradient-text me-2">Law College Gallery</span>
            <span className="premium-badge">Premium</span>
          </a>
        </div>

        <div className="flex-grow-1 mx-4 d-none d-md-block">
          <div
            className={`input-group position-relative premium-search ${
              isSearchFocused ? "focused" : ""
            }`}
            style={{ maxWidth: "600px", margin: "0 auto" }}
          >
            <input
              type="text"
              className="form-control border-0 shadow-sm rounded-pill rounded-end"
              placeholder="Search premium videos..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => setIsSearchFocused(true)}
              onBlur={() => setIsSearchFocused(false)}
              style={{
                background: darkMode
                  ? "linear-gradient(145deg, #1a202c, #0f1419)"
                  : "linear-gradient(145deg, #ffffff, #f0f0f0)",
                color: darkMode ? "white" : "#1a202c",
                border: darkMode ? "1px solid #4a5568" : "1px solid #e2e8f0",
                paddingLeft: "1.5rem",
                fontSize: "15px",
                boxShadow: darkMode
                  ? "inset 3px 3px 6px #0a0e12, inset -3px -3px 6px #1e2632"
                  : "inset 3px 3px 6px #d9d9d9, inset -3px -3px 6px #ffffff",
                height: "46px",
              }}
              aria-label="Search videos"
            />
            <button
              className="btn rounded-pill rounded-start px-4 search-btn"
              style={{
                background: darkMode
                  ? "linear-gradient(145deg, #1a202c, #0f1419)"
                  : "linear-gradient(145deg, #ffffff, #f0f0f0)",
                border: darkMode ? "1px solid #4a5568" : "1px solid #e2e8f0",
                color: darkMode ? "white" : "#4a5568",
                boxShadow: darkMode
                  ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
                  : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
                height: "46px",
              }}
              aria-label="Search"
            >
              <FaSearch size={16} />
            </button>
            <button
              className="btn btn-outline-secondary border-0 ms-2 rounded-circle p-2 nav-icon"
              style={{
                color: darkMode ? "#a0aec0" : "#718096",
                background: darkMode
                  ? "linear-gradient(145deg, #1a202c, #0f1419)"
                  : "linear-gradient(145deg, #ffffff, #f0f0f0)",
                boxShadow: darkMode
                  ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
                  : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
              }}
              aria-label="Voice search"
            >
              <FaMicrophone size={16} />
            </button>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <DarkModeToggle darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
          <button
            className="btn btn-link text-decoration-none p-2 rounded-circle nav-icon"
            style={{
              color: darkMode ? "white" : "#4a5568",
              background: darkMode
                ? "linear-gradient(145deg, #1a202c, #0f1419)"
                : "linear-gradient(145deg, #ffffff, #f0f0f0)",
              boxShadow: darkMode
                ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
                : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
            }}
            aria-label="Upload video"
          >
            <FaVideo size={18} />
          </button>
          <button
            className="btn btn-link text-decoration-none p-2 rounded-circle position-relative nav-icon"
            style={{
              color: darkMode ? "white" : "#4a5568",
              background: darkMode
                ? "linear-gradient(145deg, #1a202c, #0f1419)"
                : "linear-gradient(145deg, #ffffff, #f0f0f0)",
              boxShadow: darkMode
                ? "3px 3px 6px #0a0e12, -3px -3px 6px #1e2632"
                : "3px 3px 6px #d9d9d9, -3px -3px 6px #ffffff",
            }}
            aria-label="Notifications"
          >
            <FaBell size={18} />
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill premium-badge"
              style={{ fontSize: "10px", padding: "4px 6px" }}
            >
              3
            </span>
          </button>
          <button
            className="btn premium-user-btn p-1 position-relative"
            style={{
              color: darkMode ? "white" : "#4a5568",
              background: "linear-gradient(145deg, #8a2387, #e94057, #f27121)",
              borderRadius: "50%",
              width: "42px",
              height: "42px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label="User profile"
          >
            <FaUserCircle size={28} />
            <span className="position-absolute bottom-0 end-0 premium-user-badge">
              <FaCrown size={10} />
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};

// Premium Sidebar Component
const Sidebar = ({ darkMode, sidebarOpen }) => {
  const menuItems = [
    { icon: FaHome, label: "Home", active: true },
    { icon: FaUserCircle, label: "Judges", category: "judges" },
    { icon: FaUserCircle, label: "Lawyers", category: "lawyers" },
    { icon: FaUserCircle, label: "VCs", category: "vcs" },
    { icon: FaUserCircle, label: "Lecturers", category: "lecturers" },
    { icon: FaUserCircle, label: "Students", category: "students" },
  ];

  const premiumItems = [
    { icon: FaCrown, label: "Premium Content", premium: true },
    { icon: FaCog, label: "Settings" },
    { icon: FaQuestionCircle, label: "Help" },
    { icon: FaCommentAlt, label: "Send feedback" },
  ];

  return (
    <div
      className={`position-fixed h-100 overflow-auto transition-all premium-sidebar ${
        sidebarOpen ? "d-block" : "d-none d-lg-block"
      }`}
      style={{
        width: sidebarOpen ? "260px" : "80px",
        background: darkMode
          ? "linear-gradient(180deg, #1a202c 0%, #0f1419 100%)"
          : "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
        borderRight: darkMode ? "1px solid #2d3748" : "1px solid #e2e8f0",
        top: "70px",
        zIndex: 1000,
        transition: "all 0.3s ease",
        boxShadow: darkMode
          ? "5px 0 15px rgba(0, 0, 0, 0.2)"
          : "5px 0 15px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div className="py-3">
        {menuItems.map((item, index) => (
          <a
            key={index}
            href="#"
            className={`d-flex align-items-center px-3 py-3 text-decoration-none transition-all premium-sidebar-item ${
              item.active ? "active" : ""
            }`}
            style={{
              background: item.active
                ? darkMode
                  ? "linear-gradient(90deg, rgba(138, 35, 135, 0.2) 0%, rgba(233, 64, 87, 0.2) 50%, rgba(242, 113, 33, 0.2) 100%)"
                  : "linear-gradient(90deg, rgba(138, 35, 135, 0.1) 0%, rgba(233, 64, 87, 0.1) 50%, rgba(242, 113, 33, 0.1) 100%)"
                : "transparent",
              color: item.active
                ? darkMode
                  ? "white"
                  : "#1a202c"
                : darkMode
                ? "#a0aec0"
                : "#4a5568",
              borderRadius: "0 25px 25px 0",
              marginRight: "12px",
              fontFamily: "Roboto, sans-serif",
              fontSize: "14px",
              fontWeight: item.active ? "600" : "400",
              borderLeft: item.active ? "4px solid #e94057" : "none",
            }}
            aria-label={item.label}
          >
            <item.icon
              size={20}
              className="me-3"
              color={item.active ? "#e94057" : undefined}
            />
            {sidebarOpen && <span>{item.label}</span>}
            {item.active && sidebarOpen && (
              <div className="premium-dot ms-auto"></div>
            )}
          </a>
        ))}

        <div
          className="sidebar-divider my-3"
          style={{
            borderTop: darkMode ? "1px solid #2d3748" : "1px solid #e2e8f0",
            margin: "0 16px",
          }}
        ></div>

        <div
          className="px-3 mb-2"
          style={{
            fontSize: "12px",
            color: darkMode ? "#718096" : "#a0aec0",
            fontWeight: "600",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {sidebarOpen && "PREMIUM FEATURES"}
        </div>

        {premiumItems.map((item, index) => (
          <a
            key={index}
            href="#"
            className={`d-flex align-items-center px-3 py-3 text-decoration-none transition-all premium-sidebar-item ${
              item.premium ? "premium" : ""
            }`}
            style={{
              color: item.premium
                ? darkMode
                  ? "#FFD700"
                  : "#D4AF37"
                : darkMode
                ? "#a0aec0"
                : "#4a5568",
              borderRadius: "0 25px 25px 0",
              marginRight: "12px",
              fontFamily: "Roboto, sans-serif",
              fontSize: "14px",
              fontWeight: item.premium ? "600" : "400",
            }}
            aria-label={item.label}
          >
            <item.icon
              size={20}
              className="me-3"
              color={item.premium ? "#FFD700" : undefined}
            />
            {sidebarOpen && <span>{item.label}</span>}
            {item.premium && sidebarOpen && (
              <FaCrown size={12} className="ms-auto" color="#FFD700" />
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

// Premium Video Card Component
const VideoCard = ({ video, darkMode }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="card border-0 shadow-sm h-100 transition-all premium-video-card"
      style={{
        background: darkMode
          ? "linear-gradient(145deg, #1a202c, #0f1419)"
          : "linear-gradient(145deg, #ffffff, #f8f9fa)",
        borderRadius: "16px",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        transform: isHovered ? "translateY(-8px)" : "translateY(0)",
        boxShadow: isHovered
          ? darkMode
            ? "0 25px 50px -12px rgba(0, 0, 0, 0.5)"
            : "0 25px 50px -12px rgba(0, 0, 0, 0.15)"
          : darkMode
          ? "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          : "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        border: darkMode ? "1px solid #2d3748" : "1px solid #e2e8f0",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="position-relative overflow-hidden"
        style={{ aspectRatio: "16/9" }}
      >
        <img
          src={video.thumbnail}
          className="card-img-top w-100 h-100 object-fit-cover"
          alt={video.title}
          style={{
            transition: "transform 0.3s ease",
            transform: isHovered ? "scale(1.05)" : "scale(1)",
          }}
        />
        <div className="position-absolute top-0 end-0 m-2">
          {video.premium && (
            <span className="badge premium-badge">
              <FaCrown size={10} className="me-1" /> PREMIUM
            </span>
          )}
        </div>
        <div
          className="position-absolute bottom-0 end-0 m-2 rounded"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "2px 6px",
            fontSize: "12px",
          }}
        >
          {video.duration}
        </div>
        <div
          className="position-absolute top-50 start-50 translate-middle opacity-0 transition-all play-overlay"
          style={{
            backgroundColor: "rgba(0,0,0,0.8)",
            borderRadius: "50%",
            padding: "16px",
            transition: "all 0.3s ease",
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? "scale(1)" : "scale(0.8)",
          }}
        >
          <FaPlay color="white" size={24} />
        </div>
      </div>
      <div className="card-body p-3">
        <div className="d-flex align-items-start gap-3">
          <div className="position-relative">
            <img
              src={video.channelAvatar}
              alt={`${video.channel} avatar`}
              className="rounded-circle flex-shrink-0"
              style={{
                width: "40px",
                height: "40px",
                border: video.premium ? "2px solid #D4AF37" : "none",
              }}
            />
            {video.premium && (
              <FaCrown
                size={8}
                className="position-absolute bottom-0 end-0"
                color="#D4AF37"
              />
            )}
          </div>
          <div className="flex-grow-1 min-width-0">
            <h6
              className="card-title mb-1 fw-semibold lh-sm"
              style={{
                color: darkMode ? "white" : "#1a202c",
                fontFamily: "Roboto, sans-serif",
                fontSize: "15px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {video.title}
            </h6>
            <p
              className="card-text mb-1 d-flex align-items-center"
              style={{
                color: darkMode ? "#a0aec0" : "#718096",
                fontSize: "13px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              {video.channel}
              {video.premium && (
                <FaCrown size={10} className="ms-1" color="#D4AF37" />
              )}
            </p>
            <p
              className="card-text"
              style={{
                color: darkMode ? "#a0aec0" : "#718096",
                fontSize: "13px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              {video.views} views • {video.uploadTime}
            </p>
          </div>
          <button
            className="btn btn-link text-decoration-none p-0"
            style={{ color: darkMode ? "#a0aec0" : "#718096" }}
            aria-label="More options"
          >
            <FaEllipsisH size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

// Premium Video Grid Component
const VideoGrid = ({ videos, darkMode, sidebarOpen }) => (
  <div
    className="flex-grow-1 p-4 premium-content-area"
    style={{
      marginLeft: sidebarOpen ? "260px" : "80px",
      transition: "margin-left 0.3s ease",
      background: darkMode
        ? "radial-gradient(circle at top right, #1a202c 0%, #0f1419 100%)"
        : "radial-gradient(circle at top right, #ffffff 0%, #f8f9fa 100%)",
      minHeight: "calc(100vh - 70px)",
    }}
  >
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-12">
          <h2
            className="fw-bold mb-0"
            style={{
              color: darkMode ? "white" : "#1a202c",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "1.75rem",
            }}
          >
            Recommended Videos
          </h2>
          <p
            className="mb-0"
            style={{
              color: darkMode ? "#a0aec0" : "#718096",
              fontSize: "1rem",
            }}
          >
            Curated premium content just for you
          </p>
        </div>
      </div>
      <div className="row g-4">
        {videos.map((video) => (
          <div
            key={video.id}
            className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4"
          >
            <VideoCard video={video} darkMode={darkMode} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Main App Component
const App = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 992);

  useEffect(() => {
    // Check for saved theme preference
    const savedTheme = localStorage.getItem("darkMode");
    if (savedTheme) {
      setDarkMode(JSON.parse(savedTheme));
    }
  }, []);

  useEffect(() => {
    // Save theme preference
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
    // Update body class for global theming
    document.body.style.backgroundColor = darkMode ? "#0f1419" : "#f8f9fa";
    document.body.style.color = darkMode ? "white" : "#1a202c";
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(!darkMode);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Handle responsive sidebar with debouncing
  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setSidebarOpen(window.innerWidth >= 992);
      }, 100); // Debounce for 100ms
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once to set initial state

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div
      className="min-vh-100 premium-app"
      style={{ fontFamily: "Roboto, sans-serif" }}
    >
      <Navbar
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className="d-flex position-relative">
        <Sidebar darkMode={darkMode} sidebarOpen={sidebarOpen} />
        <VideoGrid
          videos={sampleVideos}
          darkMode={darkMode}
          sidebarOpen={sidebarOpen}
        />
      </div>
      {sidebarOpen && window.innerWidth < 992 && (
        <div
          className="position-fixed w-100 h-100 bg-black bg-opacity-50"
          style={{ top: "70px", zIndex: 999 }}
          onClick={toggleSidebar}
          aria-label="Close sidebar"
        />
      )}

      {/* Add premium CSS styles */}
      <style>
        {`
          .gradient-text {
            background: linear-gradient(90deg, #8a2387, #e94057, #f27121);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          
          .premium-badge {
            background: linear-gradient(90deg, #8a2387, #e94057, #f27121);
            color: white;
            font-size: 10px;
            padding: 4px 8px;
            border-radius: 12px;
            font-weight: 700;
          }
          
          .premium-user-badge {
            background: linear-gradient(90deg, #8a2387, #e94057, #f27121);
            color: white;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .premium-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: linear-gradient(90deg, #8a2387, #e94057, #f27121);
          }
          
          .premium-search.focused {
            transform: translateY(-2px);
            transition: transform 0.3s ease;
          }
          
          .premium-search.focused .search-btn {
            background: linear-gradient(90deg, #8a2387, #e94057, #f27121) !important;
            color: white !important;
          }
          
          .nav-icon:hover {
            transform: translateY(-2px);
            transition: transform 0.3s ease;
          }
          
          .premium-toggle:hover {
            transform: rotate(15deg);
            transition: transform 0.3s ease;
          }
          
          .premium-user-btn:hover {
            transform: scale(1.1);
            transition: transform 0.3s ease;
          }
          
          .premium-sidebar-item:hover {
            transform: translateX(4px);
            transition: transform 0.3s ease;
          }
          
          .premium-sidebar-item.active {
            font-weight: 600 !important;
          }
          
          .premium-sidebar-item.premium:hover {
            color: #FFD700 !important;
          }
          
          .premium-video-card:hover .play-overlay {
            opacity: 1 !important;
            transform: scale(1.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default App;
